import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const DeleteOSDialog = ({ open, handleClose, handleConfirm, itemName }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                style: { borderRadius: 15, padding: '10px' }
            }}
        >
            <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DeleteForeverIcon color="error" />
                <Typography variant="h6" component="span" sx={{ fontWeight: 'bold' }}>
                    Confirmar Eliminación
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    ¿Estás seguro de que deseas eliminar la obra social <strong>{itemName}</strong>?
                    Esta acción no se puede deshacer.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose} color="inherit" variant="text">
                    Cancelar
                </Button>
                <Button onClick={handleConfirm} color="error" variant="contained" autoFocus sx={{ boxShadow: 3 }}>
                    Eliminar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteOSDialog;
